<div [formGroup]="form">

    <cyno-field>
        <cyno-label>Op welke datum was de afspraak?</cyno-label>
        <cyno-datepicker
                formControlName="datum"
                id="datum"
                [selectPastDates]="true">
        </cyno-datepicker>
    </cyno-field>
    
    <cyno-field>
        <cyno-label>Op welk tijdstip was de afspraak</cyno-label>
        <cyno-time formControlName="tijdstip"></cyno-time>
    </cyno-field>
</div>